import {
  faShieldCheck,
  faList,
  faListOl,
  faVideoArrowUpRight,
  type IconDefinition,
} from "@fortawesome/pro-solid-svg-icons";
import EmbeddedVideoIcon from "components/icons/EmbeddedVideoIcon";
import { PdfIcon } from "components/icons/PdfIcon";
import { ContentTypesEnum } from "enums";

export const Icons: {
  [key in ContentTypesEnum]?: string;
} = {
  Flows: "fa-code-branch",
  [ContentTypesEnum.AllFlows]: "fa-code-branch",
  Scheduled: "fa-clock",
  Assets: "fa-copy",
  Videos: "fa-video",
  Links: "fa-link",
  Events: "fa-calendar-alt",
  Emails: "fa-envelope",
  Messages: "fa-messages",
  "Embedded Videos": "fa-video",
};

export const FaIcons: {
  [key in ContentTypesEnum]?: IconDefinition;
} = {
  Assessments: faListOl,
  Surveys: faList,
  Uploaded: faVideoArrowUpRight,
  Campaigns: faShieldCheck,
};

export const RenderIcons: {
  [key in ContentTypesEnum]?: (className?: string) => JSX.Element;
} = {
  Embedded: (className?: string) => <EmbeddedVideoIcon className={className} />,
  PDFs: (className?: string) => <PdfIcon className={className} />,
};
